import { useQuery } from "@tanstack/react-query";
import { DDD, E2Data, tx } from "../../lib/ddd/ddd";
import { useCallback, useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import JsonObject from "../APIPlaygroundComponents/JsonObject";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import classes from "../../pages/IntegrationWizard.module.scss"
import JSONPretty from "../jsonPrettyOverride/JSONPretty";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Button from "../UI/Button";
import LoadingDots from "../UI/LoadingDots";
import { OrgIdContext } from "../../store/orgId_context";
import Curl from "../APIPlaygroundComponents/Curl";
import StepSmall from "./Step/StepSmall";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
/*const e2Data_EU_WorkflowSteps = new E2Data("EU_WorkflowSteps");
e2Data_EU_WorkflowSteps.orderBy = "Step";
e2Data_EU_WorkflowSteps.filter = 'UserAccessible=true'*/
const wfstepsparams={
    orderBy: "Step",
    filter: 'UserAccessible=true'
}

const e2Data_Invoice_Audit = new E2Data("EU_Invoices_AuditTrails");
e2Data_Invoice_Audit.orderBy = "SeqNo";

//const e2Data_Invoice = new E2Data("EU_Invoices");

const StepsAndDocs = ({invoiceId, onExecute}) =>{
    const [stepsInfo, setStepsInfo] = useState([]);
    const [curlCommand, setCurlCommand] = useState("");
    const [curlView, setCurlView] = useState("");
    const [sendingRequestLoad, setSendingRequestLoad] = useState(false);
    const [response, setResponse] = useState(null);
    const [json, setJson] = useState({});
    const [stepsOnOff, setStepsOnOff] =  useState([]);
    const [stepsCompleted, setStepsCompleted] =  useState({});
    const [currentStep, setCurrentStep] =  useState(0);
    const [enableLimits, setEnableLimits] = useState(true);
    const { integrationDevice} = useContext(OrgIdContext);
    const [e2Data_EU_WorkflowSteps, setE2Data_EU_WorkflowSteps] = useState(E2Data.WithConnectionKey(apiRequestAddress, integrationDevice, "EU_WorkflowSteps").ApplyParams(wfstepsparams));

    
    const {isPending : isStepsPending, data : stepsData} = useQuery({
        queryKey: ['Data.GetEntityData', e2Data_EU_WorkflowSteps.GetParamsObject()],
        queryFn: () => e2Data_EU_WorkflowSteps.GetData(),
        staleTime: Infinity,
    })

    const handleKeyPress =  useCallback(e => {
        const {key, keyCode} = e;
        if(key==="s" && e.altKey){
            if(enableLimits){
                setStepsCompleted({});
                setStepsOnOff({});
                setCurrentStep(0);
                setEnableLimits(false);
                let id = invoiceId ? invoiceId : null;
                setJson({...json, Id:id, "Complexity": "Normal", "Steps" : []})
            }else{
                setEnableLimits(true);
                reloadStepSettings();
            }
        }
    }, [enableLimits, invoiceId]);

    useEffect(() => {
        window.addEventListener("keydown", handleKeyPress);
        return() =>{
            window.removeEventListener("keydown", handleKeyPress);
        }
    }, [handleKeyPress]);

    useEffect(() => {
        if(!isStepsPending && stepsData){
            setStepsInfo(stepsData?.result?.data||[])
            if(invoiceId){
                adjustInvoiceFromTable(invoiceId);
                //adjustStepsFromAudit(stepsData?.result?.data||[], invoiceId);
            }
        }
    }, [isStepsPending,stepsData]);

    const reloadStepSettings = () => {
        let id = invoiceId ? invoiceId : null;
        setJson({...json, Id:id, "Complexity": "Normal", "Steps" : []})
        setStepsOnOff({});
        //adjustStepsFromAudit(stepsInfo, invoiceId);
        adjustInvoiceFromTable(invoiceId);
    }

    useEffect(() => {
        let id = invoiceId ? invoiceId : null;
        setJson({...json, Id:id, "Complexity": "Normal", "Steps" : []})
        setStepsOnOff({});
        //adjustStepsFromAudit(stepsInfo, invoiceId);
        adjustInvoiceFromTable(invoiceId);
    }, [invoiceId])

    const adjustInvoiceFromTable = (invoiceId) => {
        if(!invoiceId) return;

        const e2Data_Invoice = E2Data.WithConnectionKey(apiRequestAddress, integrationDevice, "EU_Invoices");
        e2Data_Invoice.filter = `Id="${invoiceId}"`;
        e2Data_Invoice.GetData().then(res=>{
            //console.log(res);
            let data = res?.result?.data;
            if(!data || data.lenght===0 || !data[0].Step)
                return setCurrentStep(0);

            setCurrentStep(data[0].StepStatus === "Error" ? getPreviousStep(parseInt(data[0].Step)) : parseInt(data[0].Step));
        })
    }

    const getPreviousStep = (step) => {
        for(let i=0;i<stepsInfo.length;i++){
            if(parseInt(stepsInfo[i].Step) === step){
                if(i===0)
                    return 0;
                return parseInt(stepsInfo[i-1].Step);
            }
        }
        return 0;
    }

    const adjustStepsFromAudit = (stepsInfo, invoiceId) => {
        if(!stepsInfo || !invoiceId)
            return;

        e2Data_Invoice_Audit.filter = `EU_InvoicesMC="${invoiceId}" AND Error=false`;
        e2Data_Invoice_Audit.GetData().then(res =>{
            if(!res?.result?.data){
                setStepsCompleted({});
                setCurrentStep(0);
                return;
            }
            let data = res?.result?.data;
            let completed = {};
            let _currentStep = 0;
            stepsInfo.forEach(step => {

                data.forEach(audit => {
                    if(audit.Action && audit.Action.indexOf(step.Step) > -1){
                        completed[step.Step] = true;
                        _currentStep = step.Step;
                    }
                })
            });
            setStepsCompleted(completed);
            setCurrentStep(_currentStep);
        });
    }

    const executeJsonCommand = () =>{
        setSendingRequestLoad(true);
        setResponse("");

        const ddd = DDD.WithConnectionKey(apiRequestAddress, integrationDevice);
        ddd.DDDI_ExecuteSteps(json).then((res) => {
            setSendingRequestLoad(false);
            setResponse(res);
            
            setStepsOnOff({});
            let id = invoiceId ? invoiceId : null;
            setJson({...json, Id:id, "Complexity": "Normal", "Steps" : []})
            //adjustStepsFromAudit(stepsInfo, invoiceId);
            adjustInvoiceFromTable(invoiceId);
            if(onExecute)
                onExecute(res);
        });
    }

    useEffect(() => {
        const jsonString = JSON.stringify(JSON.stringify(json));

       /* const curlCmd = `curl -X POST https://${window.location.hostname}/api/service/EUeInvoices.DDDI_ExecuteSteps -H "Authorization: IoT ${integrationDevice}:EUeInvoices" -H "Content-Type: application/json" -d ${jsonString}`;
        setCurlCommand(curlCmd);*/
        let color = "#12bb12"
        const curlCmd = tx(`curl -X POST https://${window.location.hostname}/api/service/EUeInvoices.DDDI_ExecuteSteps -H "Authorization: IoT ${integrationDevice}:EUeInvoices" -H "Content-Type: application/json" -d ${jsonString}`);
        const endpoint = tx("EUeInvoices.DDDI_ExecuteSteps");
        const curlCmdView = <span>curl -X POST https://{window.location.hostname}/api/service/<span style={{color:color}}>{endpoint}</span> -H "Authorization: IoT <span style={{color:color}}>{integrationDevice}</span>:EUeInvoices" -H "Content-Type: application/json" -d <span style={{color:color}}>{jsonString}</span></span>
        setCurlCommand(curlCmd);
        setCurlView(curlCmdView);
    }, [json, integrationDevice])

    const onStepChanged = (step, value) =>{
        let newSteps = {...stepsOnOff, [step]:value};
        setStepsOnOff(newSteps);
        refreshJson(newSteps);
    }

    const refreshJson = (steps) =>{
        let arr = [];
        for(let x in steps){
            if(steps[x] === true)
                arr.push(parseInt(x));
        }
        setJson({...json, Steps:arr})
    }

    

    return(
        <>
        <Row className = "g-5">
            <Col className="col-md-6 order-md-last">
                <div className={classes["steps-wrapper"]} style={{textAlign:"center"}}>
                    <h3>{tx("DDDI_ExecuteSteps")}</h3>
                    This is the command you can execute from your side or click on the execute button bellow.
                    {/* {sendingRequestLoad && (<h3>Executing...</h3>)}
                    {!sendingRequestLoad && (<h3>Executed</h3>)} */}
                    <Curl
                        currentCurl={curlCommand}
                        currentCurlView={curlView}
                        currentJson={json}
                        activeApi="DDDI_ExecuteSteps"
                        connectionKey={integrationDevice}
                    />
                    <Button style={{fontSize:"2rem", marginTop:"1rem", marginBottom:"1rem"}} onClick={executeJsonCommand}><CloudUploadIcon style={{marginRight:"1rem"}}/>Execute</Button>
                    {sendingRequestLoad && (<LoadingDots />)}
                    {!sendingRequestLoad && response!==null && (
                    <div style={{textAlign : "left", paddingTop : "5px"}} id="execute-json-response">
                        <JsonObject response={response} />
                    </div>
                    )}
                </div>
            </Col>
            
            <Col className="col-md-5">
                <div className={classes["steps-wrapper"]} style={{height:"35vh", marginBottom:"1rem"}}>
                    {stepsInfo.map((step, index) => 
                        <StepSmall key={step.Id} checked = {stepsOnOff[step.Step]} onStepChange={onStepChanged} completed={stepsCompleted[step.Step]} enabled={step.Step>currentStep} stepNumber={step.Step} stepShortDescription={step.StepDescription} stepLongDescription={step.StepUIDescription}></StepSmall>
                    )}
                </div>
                <div className={`${classes["form-wrapper"]} ${classes["form-wrapper-json"]}`} style={{textAlign : "left", height:"35vh"}} >
                    <JSONPretty data={json} ></JSONPretty>
                </div>
                
            </Col>
            <Col className="my-auto p-0 m-0">
                <div ><ArrowForwardIcon style={{fontSize:"2rem"}}/></div>
            </Col>
        </Row>
        </>
    )
}

export default StepsAndDocs;
